module.exports = __webpack_public_path__ + "media/images/landing/logo-lafluence-5bafb8a15f1064e942e770aa256c3c5b.svg";